<template>
  <v-app id="app_total_collections">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">TOTAL COLLECTIONS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse collection data in a variety of stores.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-4" elevation="1" border="sm opacity-1" rounded="lg">
        <v-expansion-panels v-model="panelOpen" multiple>
          <v-expansion-panel value="filters" elevation="0">
            <v-expansion-panel-title expand-icon="mdi-menu-down">
              <v-icon class="mr-3">mdi-filter-menu-outline</v-icon>
              <span class="text-body-1 font-weight-bold">FILTERS</span>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row class="mt-2" dense>

                <v-col cols="12" md="4" class="py-1">
                  <v-date-input
                    v-model="dates"
                    prepend-inner-icon="$calendar"
                    prepend-icon=""
                    label="Select Date (or Date Range)"
                    persistent-hint
                    multiple="range"
                    density="comfortable"
                    class="custom_input_field_color"
                    variant="outlined"
                    @click:append-inner="clearDateRange"
                  ></v-date-input>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectDistrict"
                    :items="areaLists"
                    item-title="text"
                    item-value="value"
                    label="Area"
                    placeholder="Select area"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    :loading="areasLoading"
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedAgent"
                    :items="agentListsWithDetails"
                    density="comfortable"
                    clearable
                    item-title="text"
                    item-value="value"
                    class="custom_input_field_color"
                    label="Sales Rep"
                    multiple
                    placeholder="Select sales representative"
                    variant="outlined"
                    :loading="salesRepsLoading"
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :title="undefined">
                        <template v-slot:prepend>
                          <v-checkbox-btn :model-value="props.selected"></v-checkbox-btn>
                        </template>
                        <v-list-item-title>{{ item.raw.text }}</v-list-item-title>
                        <v-list-item-subtitle style="color: #01579B; font-size: 11px;">
                          REG NO: {{ item.raw.registration }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                        close-icon="mdi-close-circle"
                      >
                        {{ item.raw.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedRoute"
                    :items="routeTypeOptions"
                    item-title="text"
                    item-value="value"
                    label="Route"
                    placeholder="Select route"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title || item.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedDealer"
                    :items="dealerListsWithDetails"
                    clearable
                    density="comfortable"
                    item-title="text"
                    item-value="value"
                    label="Dealer"
                    class="custom_input_field_color"
                    multiple
                    placeholder="Select dealer"
                    variant="outlined"
                    :loading="dealersLoading"
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :title="undefined">
                        <template v-slot:prepend>
                          <v-checkbox-btn :model-value="props.selected"></v-checkbox-btn>
                        </template>
                        <v-list-item-title>{{ item.raw.text }}</v-list-item-title>
                        <v-list-item-subtitle style="color: #01579B; font-size: 11px;">
                          REG NO: {{ item.raw.registration }}
                        </v-list-item-subtitle>
                      </v-list-item>
                    </template>
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedStatus"
                    :items="paymentStatusOptions"
                    item-title="text"
                    item-value="value"
                    label="Payment Status"
                    placeholder="Select payment status"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedCollectionType"
                    :items="collectionTypeOptions"
                    item-title="text"
                    item-value="value"
                    label="Collection Type"
                    placeholder="Select type"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-autocomplete
                    v-model="selectedCompany"
                    :items="hardcodedCompanyLists"
                    item-title="text"
                    item-value="value"
                    label="Piyestra Company"
                    placeholder="Select company"
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    multiple
                    clearable
                    hide-no-data
                    hide-details="auto"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        color="#e7e7e7"
                        variant="flat"
                        class="text-black font-weight-medium"
                        size="small"
                        closable
                      >
                        {{ item.title }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" class="py-1">
                  <v-text-field
                    v-model="search"
                    clearable
                    label="Search"
                    placeholder="Search by Sales Rep, Dealer, Receipt No, Invoice No..."
                    variant="outlined"
                    density="comfortable"
                    class="custom_input_field_color"
                    prepend-inner-icon="mdi-magnify"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-divider class="mb-3 mt-2"></v-divider>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card-text class="table-wrapper pa-0">
          <v-data-table-server
            v-model:page="currentPage"
            v-model:items-per-page="perPage"
            :headers="headers"
            :items="filteredCollections"
            :items-length="totalRecords"
            :items-per-page-options="perPageOptions"
            item-value="id"
            class="px-2 custom_table_normal compact-table"
            :loading="loading"
            loading-text="Loading data..."
            fixed-header
            height="calc(100vh - 260px)"
          >

            <template v-slot:[`item.date_info`]="{ item }">
              <div>
                <p class="text-caption font-weight-medium">{{ formatDateTimeForDisplay(item.created_at) }}</p>
                <v-divider class="my-1"></v-divider>
              </div>
            </template>

            <template v-slot:[`item.salesrep_info`]="{ item }">
              <div>
                <p class="font-weight-medium text-body-2 mt-1" style="color: #01579B;">{{ item.saleRep_name || 'N/A' }}</p>
                <v-divider class="mb-1" thickness="1"></v-divider>
                <p style="color: #424242; font-size: 11px" class="mb-1 font-weight-medium">Code: {{ item.saleRep_userCode || 'N/A' }}</p>
              </div>
            </template>

            <template v-slot:[`item.dealer_info`]="{ item }">
              <div>
                <p class="font-weight-medium text-body-2 mt-1" style="color: #01579B;">{{ item.dealer_name || 'N/A' }}</p>
                <v-divider class="mb-1" thickness="1"></v-divider>
                <p style="color: #424242; font-size: 11px" class="mb-1 font-weight-medium">Code: {{ item.dealer_code || 'N/A' }}</p>
              </div>
            </template>

            <template v-slot:[`item.receipt_info`]="{ item }">
              <div>
                <p class="font-weight-medium text-body-2 mt-1">Receipt: {{ item.receipt_id }}</p>
                <v-divider class="mb-1" thickness="1"></v-divider>
                <p style="color: #01579B; font-size: 12px" class="mb-1">Method: {{ item.payment_method }}</p>
              </div>
            </template>

            <template v-slot:[`item.manual_receipt_number`]="{ item }">
              <div>
                <v-chip color="#01579B" variant="flat" size="small" class="font-weight-medium">
                  {{ getManualReceiptNumber(item) }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.invoice_numbers`]="{ item }">
              <div v-if="item.items && item.items.length" class="invoice-list">
                <v-chip
                  v-for="(inv, idx) in item.items.slice(0, 3)"
                  :key="idx"
                  class="mb-1"
                  size="x-small"
                  variant="outlined"
                  color="primary"
                >
                  {{ inv.document_no }}
                </v-chip>
                <v-chip v-if="item.items.length > 3" size="x-small" color="grey" variant="flat">
                  +{{ item.items.length - 3 }} more
                </v-chip>
              </div>
              <div v-else>
                <p class="text-caption text-grey">No invoices</p>
              </div>
            </template>

            <template v-slot:[`item.collection_amount`]="{ item }">
              <div v-if="item.items && item.items.length">
                <v-card
                  v-for="(inv, idx) in item.items"
                  :key="idx"
                  class="pa-1 mb-1"
                  variant="outlined"
                  elevation="0"
                  border="sm opacity-1"
                  rounded="sm"
                  style="min-width: 120px;"
                >
                  <div class="d-flex justify-space-between align-center">
                    <span class="text-caption font-weight-medium" style="color: #01579B;">
                      {{ inv.document_no }}
                    </span>
                    <span class="text-body-2 font-weight-bold" style="color: #01579B;">
                      {{ formatNumber(inv.cash_amount || inv.amount || 0) }}
                    </span>
                  </div>
                </v-card>
              </div>
              <div v-else>
                <p class="text-caption text-grey">No invoices</p>
              </div>
            </template>

            <template v-slot:[`item.payment_status`]="{ item }">
              <v-chip v-if="item.payment_status === 'UNPAID'" class="custom_orange_chip" size="small" variant="outlined">
                {{ item.payment_status }}
                <v-icon class="ml-2">mdi-progress-check</v-icon>
              </v-chip>
              <v-chip v-else-if="item.payment_status === 'PAID'" class="custom_green_chip" size="small" variant="outlined">
                {{ item.payment_status }}
                <v-icon class="ml-2">mdi-check</v-icon>
              </v-chip>
              <v-chip v-else-if="item.payment_status === 'OVERDUE'" class="custom_red_chip" size="small" variant="outlined">
                {{ item.payment_status }}
                <v-icon class="ml-2">mdi-close</v-icon>
              </v-chip>
              <v-chip v-else-if="item.payment_status === 'ADVANCE'" class="custom_blue_chip" size="small" variant="outlined">
                {{ item.payment_status }}
                <v-icon class="ml-2">mdi-lightning-bolt</v-icon>
              </v-chip>
              <v-chip v-else class="custom_blue_chip" size="small" variant="outlined">
                {{ item.payment_status || 'N/A' }}
              </v-chip>
            </template>

            <template v-slot:[`item.amount_info`]="{ item }">
              <v-card class="pa-1" variant="outlined" elevation="0" border="sm opacity-1" rounded="md">
                <p style="color: #01579B; font-weight: 500;">{{ formatNumber(item.collect_total_amount) }}</p>
                <v-divider class="my-1"></v-divider>
              </v-card>
            </template>

            <template v-slot:[`item.receipt_status_header`]="{ item }">
              <div>
                <v-chip
                  :color="getReceiptStatusColor(item.receipt_status)"
                  size="small"
                  variant="flat"
                  class="font-weight-medium"
                >
                  {{ item.receipt_status === 'undefined' ? 'N/A' : item.receipt_status }}
                </v-chip>
              </div>
            </template>

            <template v-slot:[`item.items`]="{ item }">
              <div v-if="item.items && item.items.length" class="items-list">
                <v-card v-for="inv in item.items" :key="inv.id" class="mb-1 pa-1" variant="outlined" rounded="sm">
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <p class="font-weight-medium text-caption">{{ inv.document_type }}: {{ inv.document_no }}</p>
                      <p class="text-caption">Amount: LKR. {{ formatNumber(inv.amount) }}</p>
                    </div>
                    <v-chip :color="inv.status === 'Full_Payment' ? 'success' : 'warning'" size="x-small" text-color="white">
                      {{ inv.status === 'Full_Payment' ? 'PAID' : inv.status }}
                    </v-chip>
                  </div>
                  <div class="d-flex justify-space-between mt-1">
                    <span class="text-caption">Assigned: LKR. {{ formatNumber(inv.assigned_amount) }}</span>
                    <span class="text-caption">Remaining: LKR. {{ formatNumber(inv.remaining_amount) }}</span>
                  </div>
                </v-card>
              </div>
              <div v-else>
                <p class="text-caption text-grey">No items</p>
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-menu transition="slide-x-transition">
                <template v-slot:activator="{ props }">
                  <v-btn style="background-color: #800080; color: white;" variant="flat" size="small" v-bind="props">
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="permissions.read" @click="viewItem(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.write && item.receipt_status && item.receipt_status.toLowerCase() === 'collected'" @click="rivesitem(item)">
                    <v-list-item-title class="custom_font_color_delete" style="color: #BB0000 !important;">REVERSAL</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete" style="color: #BB0000 !important;">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table-server>
        </v-card-text>

        <v-divider thickness="2"></v-divider>
        <v-card-text class="custom_tool_bar_style d-flex justify-end align-center py-2">
          <v-btn class="custom_pdf_btn" variant="outlined" size="small" @click="exportPDF">
            <v-icon size="small">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-3" variant="outlined" size="small" @click="exportExcel">
            <v-icon size="small">mdi-file-excel</v-icon>&nbsp;&nbsp;EXCEL
          </v-btn>
        </v-card-text>
      </v-card>

      <v-dialog v-model="deleteDialog" max-width="500" persistent>
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE COLLECTION DATA</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="deleteDialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this collection record?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This collection record will be deleted immediately. Once deleted, it can no longer be used for any
                  purpose. <span style="color: #0D47A1; font-weight: 500;">Further, this module might be related with
                    some other module, so please confirm before deleting this.</span>
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn class="ml-3" style="background-color: #D32F2F; color: white;"
                    @click="deleteItem" :loading="deleteLoading">DELETE</v-btn>
                  <v-btn class="ml-3" style="background-color: #9E9E9E; color: white;"
                    @click="deleteDialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="rivesDialog" max-width="500" persistent>
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">REVERSAL COLLECTION DATA</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="closeReversalDialog" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #27F535" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to reverse this collection record?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This collection record will be reversed immediately. Once reversed, it will be removed from active collections.
                </p>

                <v-card v-if="itemToDelete" variant="outlined" class="mt-3 pa-2" elevation="0">
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <p class="text-caption font-weight-medium">Receipt ID: {{ itemToDelete.receipt_id }}</p>
                      <p class="text-caption">Dealer: {{ itemToDelete.dealer_name || 'N/A' }}</p>
                      <p class="text-caption">Amount: LKR. {{ formatNumber(itemToDelete.collect_total_amount) }}</p>
                    </div>
                    <v-icon color="#27F535">mdi-restore</v-icon>
                  </div>
                </v-card>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn
                    class="ml-3"
                    style="background-color: #27F535; color: white;"
                    @click="processReversal"
                    :loading="reversalLoading"
                  >
                    CONFIRM REVERSAL
                  </v-btn>
                  <v-btn
                    class="ml-3"
                    style="background-color: #9E9E9E; color: white;"
                    @click="closeReversalDialog"
                  >
                    CANCEL
                  </v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import { EventBus } from "@/plugins/event-bus";
import { mapActions } from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getPermissions } from "@/plugins/permissions";
import * as XLSX from 'xlsx';
import _ from 'lodash';

export default {
  name: 'TotalCollections',
  data() {
    return {
      panelOpen: [],
      dates: [],
      search: '',
      selectedAgent: [],
      selectedRoute: [],
      selectedDealer: [],
      selectDistrict: [],
      selectedStatus: [],
      selectedCollectionType: [],
      selectedCompany: [],

      cancelTokenSource: null,

      isSearchActive: false,
      searchableFullData: [],
      unfilteredTotalRecords: 0,

      hardcodedCompanyLists: [
        { text: 'Piyestra Furniture (Pvt) Ltd', value: 'Piyestra Furniture (Pvt) Ltd', title: 'Piyestra Furniture (Pvt) Ltd' },
        { text: 'D.R.Industries (Pvt) Ltd', value: 'D.R.Industries (Pvt) Ltd', title: 'D.R.Industries (Pvt) Ltd' },
        { text: 'D.R.Home Appliances (Pvt) Ltd', value: 'D.R.Home Appliances (Pvt) Ltd', title: 'D.R.Home Appliances (Pvt) Ltd' }
      ],

      paymentStatusOptions: [
        { text: 'OVERDUE', value: 'OVERDUE', title: 'OVERDUE' },
        { text: 'UNPAID', value: 'UNPAID', title: 'UNPAID' },
        { text: 'ADVANCE', value: 'ADVANCE', title: 'ADVANCE' },
      ],

      collectionTypeOptions: [
        { text: 'CASH', value: 'CASH', title: 'CASH' },
        { text: 'BANK', value: 'BANK', title: 'BANK' },
        { text: 'CHEQUE', value: 'CHEQUE', title: 'CHEQUE' },
      ],

      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      lastPage: 1,
      totalRecords: 0,
      fromRecord: 0,
      toRecord: 0,
      loading: false,
      salesRepsLoading: false,
      dealersLoading: false,
      areasLoading: false,
      deleteLoading: false,
      reversalLoading: false,

      agentListsWithDetails: [],
      routeTypeOptions: [
        { text: 'Assign Route Plan', value: 'Assign Route Plan' },
        { text: 'Direct', value: 'Direct' },
        { text: 'Own Route Plan', value: 'Own Route Plan' },
      ],
      dealerListsWithDetails: [],
      areaLists: [],

      deleteDialog: false,
      rivesDialog: false,
      itemToDelete: null,

      headers: [
        { text: 'Date & Time', value: 'date_info', title: 'Collection Date & Time', sortable: false },
        { text: 'Sales Rep', value: 'salesrep_info', title: 'SALES EXECUTIVE', sortable: false },
        { text: 'Dealer Info', value: 'dealer_info', title: 'DEALER INFO', sortable: false },
        { text: 'Receipt Info', value: 'receipt_info', title: 'RECEIPT NO', sortable: false },
        { text: 'Manual Receipt No', value: 'manual_receipt_number', title: 'MANUAL RECEIPT NO', sortable: false },
        { text: 'Total Amount', value: 'amount_info', title: 'TOTAL COLLECTION AMOUNT (LKR)', sortable: false },
        { text: 'Payment Status', value: 'payment_status', title: 'PAYMENT STATUS', sortable: true },
        { text: 'Receipt Status', value: 'receipt_status_header', title: 'RECEIPT STATUS', sortable: false },
        { text: 'Invoice Numbers', value: 'invoice_numbers', title: 'INVOICE NUMBER(S)', sortable: false },
        { text: 'Collection Amount', value: 'collection_amount', title: 'INVOICE AMOUNTS (LKR)', sortable: false },
        { text: 'Actions', value: 'action', title: 'ACTION', sortable: false },
      ],

      receiptData: [],
      allReceiptData: [],

      permissions: { read: false, write: false, delete: false },
      baseUrl: process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_API_BASE_URL,

      loadedPage: 1,
      loadedPerPage: 10,
    };
  },

  computed: {
    filteredCollections() {
      const term = (this.search || '').trim().toLowerCase();

      if (!term) {
        return this.receiptData;
      }

      return this.receiptData.filter(item => {
        if (!item) return false;

        const parts = [
          item.saleRep_name,
          item.saleRep_userCode,
          item.dealer_name,
          item.dealer_code,
          item.receipt_id,
          this.getManualReceiptNumber(item),
        ];

        if (Array.isArray(item.items)) {
          item.items.forEach(inv => {
            if (inv && inv.document_no) {
              parts.push(inv.document_no);
            }
          });
        }

        return parts.some(part => {
          if (part === null || part === undefined) return false;
          return String(part).toLowerCase().includes(term);
        });
      });
    },
  },

  methods: {
    ...mapActions(['updateSharedDataCollection']),

    /* ------------------------------------------------------------------ */
    /*  PERSISTENCE HELPERS (sessionStorage)                              */
    /* ------------------------------------------------------------------ */
    _saveFiltersToSession() {
      const filters = {
        dates: this.dates,
        search: this.search,
        selectedAgent: this.selectedAgent,
        selectedRoute: this.selectedRoute,
        selectedDealer: this.selectedDealer,
        selectDistrict: this.selectDistrict,
        selectedStatus: this.selectedStatus,
        selectedCollectionType: this.selectedCollectionType,
        selectedCompany: this.selectedCompany,
        currentPage: this.currentPage,
        perPage: this.perPage,
        panelOpen: this.panelOpen,
      };
      sessionStorage.setItem('totalCollectionsFilters', JSON.stringify(filters));
    },

    _restoreFiltersFromSession() {
      const saved = sessionStorage.getItem('totalCollectionsFilters');
      if (!saved) return false;
      try {
        const filters = JSON.parse(saved);
        if (filters.dates) this.dates = filters.dates;
        if (filters.search !== undefined) this.search = filters.search;
        if (filters.selectedAgent) this.selectedAgent = filters.selectedAgent;
        if (filters.selectedRoute) this.selectedRoute = filters.selectedRoute;
        if (filters.selectedDealer) this.selectedDealer = filters.selectedDealer;
        if (filters.selectDistrict) this.selectDistrict = filters.selectDistrict;
        if (filters.selectedStatus) this.selectedStatus = filters.selectedStatus;
        if (filters.selectedCollectionType) this.selectedCollectionType = filters.selectedCollectionType;
        if (filters.selectedCompany) this.selectedCompany = filters.selectedCompany;
        if (filters.currentPage) this.currentPage = filters.currentPage;
        if (filters.perPage) this.perPage = filters.perPage;
        if (filters.panelOpen) this.panelOpen = filters.panelOpen;
        return true;
      } catch (e) {
        console.warn('Failed to restore filters', e);
        return false;
      }
    },

    /* ------------------------------------------------------------------ */
    /*  SHARED EXPORT ROW BUILDER – single source of truth for PDF/Excel   */
    /* ------------------------------------------------------------------ */
    buildExportRow(item, index, invoice, invoiceIndex, isFirstInvoiceOfReceipt) {
      const safe = (v) => (v === undefined || v === null || v === '' ? '-' : v);

      let chequeNo = '-';
      let bankName = '-';

      if (invoice) {
        chequeNo = this.pickIndexedValue(invoice.cheque_number, invoiceIndex);
        bankName = this.pickIndexedValue(invoice.bank_name, invoiceIndex);
      }

      return {
        sno: index,
        receipt_id: safe(item.receipt_id),
        manual_receipt_no: this.getManualReceiptNumber(item),
        date_time: this.formatDateTimeForDisplay(item.created_at),

        sales_rep_name: safe(item.saleRep_name),
        sales_rep_code: safe(item.saleRep_userCode),
        route_type: safe(item.route_type),

        dealer_name: safe(item.dealer_name),
        dealer_code: safe(item.dealer_code),

        total_collection: isFirstInvoiceOfReceipt
          ? this.formatNumber(item.collect_total_amount || 0)
          : '',

        payment_method: safe(item.payment_method),
        payment_status: safe(item.payment_status),
        receipt_status: safe(item.receipt_status),

        invoice_no: invoice ? safe(invoice.document_no) : '-',
        invoice_type: invoice ? safe(invoice.document_type) : '-',
        invoice_amount: invoice
          ? this.formatNumber(invoice.amount || invoice.cash_amount || 0)
          : '-',
        invoice_status: invoice ? safe(invoice.status || invoice.payment_status) : '-',
        invoice_date: invoice
          ? (invoice.posting_date ? this.formatDateForDisplay(invoice.posting_date) : '-')
          : '-',
        due_date: invoice
          ? (invoice.due_date ? this.formatDateForDisplay(invoice.due_date) : '-')
          : '-',

        cheque_no: chequeNo,
        bank_name: bankName,
      };
    },

    pickIndexedValue(raw, index) {
      if (raw === undefined || raw === null || raw === '') return '-';

      let arr = null;

      if (Array.isArray(raw)) {
        arr = raw;
      } else if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (trimmed.startsWith('[')) {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) arr = parsed;
          } catch (e) {
            arr = null;
          }
        }
        if (!arr) {
          if (trimmed.includes(',')) {
            arr = trimmed.split(',').map(s => s.trim());
          } else {
            return trimmed || '-';
          }
        }
      } else {
        return String(raw);
      }

      if (!arr || arr.length === 0) return '-';
      const chosen = arr[index] !== undefined && arr[index] !== null && arr[index] !== ''
        ? arr[index]
        : arr[0];
      return chosen === undefined || chosen === null || chosen === '' ? '-' : String(chosen);
    },

    getExportColumns() {
      return [
        { key: 'sno',                label: '#',                            width: 20 },
        { key: 'receipt_id',         label: 'Receipt ID',                   width: 90 },
        { key: 'manual_receipt_no',  label: 'Manual Receipt No',            width: 100 },
        { key: 'date_time',          label: 'Date & Time',                  width: 100 },
        { key: 'sales_rep_name',     label: 'Sales Rep',                    width: 110 },
        { key: 'sales_rep_code',     label: 'Rep Code',                     width: 60 },
        { key: 'route_type',         label: 'Route',                        width: 80 },
        { key: 'dealer_name',        label: 'Dealer',                       width: 130 },
        { key: 'dealer_code',        label: 'Dealer Code',                  width: 70 },
        { key: 'total_collection',   label: 'Total Collection (LKR)',       width: 110 },
        { key: 'payment_method',     label: 'Method',                       width: 60 },
        { key: 'payment_status',     label: 'Payment Status',               width: 90 },
        { key: 'receipt_status',     label: 'Receipt Status',               width: 90 },
        { key: 'invoice_no',         label: 'Invoice No',                   width: 90 },
        { key: 'invoice_type',       label: 'Invoice Type',                 width: 70 },
        { key: 'invoice_amount',     label: 'Invoice Amount (LKR)',         width: 110 },
        { key: 'invoice_status',     label: 'Invoice Status',               width: 90 },
        { key: 'invoice_date',       label: 'Invoice Date',                 width: 80 },
        { key: 'due_date',           label: 'Due Date',                     width: 80 },
        { key: 'cheque_no',          label: 'Cheque No',                    width: 80 },
        { key: 'bank_name',          label: 'Bank Name',                    width: 100 },
      ];
    },

    buildExportRows(receipts) {
      const rows = [];
      let counter = 1;

      receipts.forEach((item) => {
        const invoices = Array.isArray(item.items) ? item.items : [];

        if (invoices.length === 0) {
          rows.push(this.buildExportRow(item, counter++, null, 0, true));
        } else {
          invoices.forEach((inv, idx) => {
            rows.push(this.buildExportRow(item, counter++, inv, idx, idx === 0));
          });
        }
      });

      return rows;
    },

    /* ------------------------------------------------------------------ */
    /*  LOGO LOADING HELPER                                                */
    /* ------------------------------------------------------------------ */
    loadImageAsBase64(imagePath) {
      return new Promise((resolve) => {
        try {
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            try {
              resolve(canvas.toDataURL('image/png'));
            } catch (e) {
              console.warn('Canvas toDataURL failed:', e);
              resolve(null);
            }
          };
          img.onerror = () => {
            console.warn('Failed to load image:', imagePath);
            resolve(null);
          };
          img.src = imagePath;
        } catch (e) {
          console.warn('Error loading image:', e);
          resolve(null);
        }
      });
    },

    /* ------------------------------------------------------------------ */
    /*  EXISTING HELPERS                                                   */
    /* ------------------------------------------------------------------ */

    getManualReceiptNumber(item) {
      if (!item) return 'N/A';

      const candidates = [
        item.manual_receipt_number,
        item.manual_receipt_no,
        item.manualReceiptNumber,
        item.manualReceiptNo,
        item.manual_receipt,
        item.receipt_manual_number,
        item.receiptManualNumber,
        item.manual_receipt_num,
        item.manualReceiptNum,
        item.manual_no,
        item.manualNumber,
        item.receipt_no_manual,
        item.receiptNumberManual,
      ];

      const found = candidates.find(v => v !== undefined && v !== null && String(v).trim() !== '');
      return found !== undefined ? found : 'N/A';
    },

    getChequeNumberForInvoice(item, invoiceIndex) {
      if (!item.items || !item.items.length) return '-';
      const chequeNumbers = [];
      item.items.forEach(inv => {
        if (inv.cheque_number) {
          try {
            if (typeof inv.cheque_number === 'string' && inv.cheque_number.startsWith('[')) {
              const parsed = JSON.parse(inv.cheque_number);
              if (Array.isArray(parsed)) chequeNumbers.push(...parsed);
              else chequeNumbers.push(inv.cheque_number);
            } else if (typeof inv.cheque_number === 'string') {
              chequeNumbers.push(inv.cheque_number);
            } else if (Array.isArray(inv.cheque_number)) {
              chequeNumbers.push(...inv.cheque_number);
            }
          } catch (e) {
            chequeNumbers.push(inv.cheque_number);
          }
        }
      });

      if (chequeNumbers.length > 0) {
        if (chequeNumbers.length === 1) return chequeNumbers[0];
        return chequeNumbers[invoiceIndex] || chequeNumbers[0] || '-';
      }
      return '-';
    },

    getBankNameForInvoice(item, invoiceIndex) {
      if (!item.items || !item.items.length) return '-';
      const bankNames = [];
      item.items.forEach(inv => {
        if (inv.bank_name) {
          try {
            if (typeof inv.bank_name === 'string' && inv.bank_name.startsWith('[')) {
              const parsed = JSON.parse(inv.bank_name);
              if (Array.isArray(parsed)) bankNames.push(...parsed);
              else bankNames.push(inv.bank_name);
            } else if (typeof inv.bank_name === 'string') {
              bankNames.push(inv.bank_name);
            } else if (Array.isArray(inv.bank_name)) {
              bankNames.push(...inv.bank_name);
            }
          } catch (e) {
            bankNames.push(inv.bank_name);
          }
        }
      });

      if (bankNames.length > 0) {
        if (bankNames.length === 1) return bankNames[0];
        return bankNames[invoiceIndex] || bankNames[0] || '-';
      }
      return '-';
    },

    getChequeNumbers(item) {
      if (!item.items || !item.items.length) return '-';
      const chequeNumbers = [];
      item.items.forEach(invoice => {
        if (invoice.cheque_number) {
          try {
            if (typeof invoice.cheque_number === 'string' && invoice.cheque_number.startsWith('[')) {
              const parsed = JSON.parse(invoice.cheque_number);
              if (Array.isArray(parsed)) chequeNumbers.push(...parsed);
              else chequeNumbers.push(invoice.cheque_number);
            } else if (typeof invoice.cheque_number === 'string') {
              chequeNumbers.push(invoice.cheque_number);
            } else if (Array.isArray(invoice.cheque_number)) {
              chequeNumbers.push(...invoice.cheque_number);
            }
          } catch (e) {
            chequeNumbers.push(invoice.cheque_number);
          }
        }
      });
      return chequeNumbers.length > 0 ? chequeNumbers.join(', ') : '-';
    },

    getBankNames(item) {
      if (!item.items || !item.items.length) return '-';
      const bankNames = [];
      item.items.forEach(invoice => {
        if (invoice.bank_name) {
          try {
            if (typeof invoice.bank_name === 'string' && invoice.bank_name.startsWith('[')) {
              const parsed = JSON.parse(invoice.bank_name);
              if (Array.isArray(parsed)) bankNames.push(...parsed);
              else bankNames.push(invoice.bank_name);
            } else if (typeof invoice.bank_name === 'string') {
              bankNames.push(invoice.bank_name);
            } else if (Array.isArray(invoice.bank_name)) {
              bankNames.push(...invoice.bank_name);
            }
          } catch (e) {
            bankNames.push(invoice.bank_name);
          }
        }
      });
      return bankNames.length > 0 ? bankNames.join(', ') : '-';
    },

    getInvoiceNumbersString(item) {
      if (!item.items || !item.items.length) return 'N/A';
      return item.items.map(inv => inv.document_no).join(', ');
    },

    getInvoiceAmountsString(item) {
      if (!item.items || !item.items.length) return 'N/A';
      return item.items.map(inv => `LKR ${this.formatNumber(inv.amount)}`).join(', ');
    },

    getInvoiceDatesString(item) {
      if (!item.items || !item.items.length) return 'N/A';
      return item.items.map(inv => inv.posting_date ? this.formatDateForDisplay(inv.posting_date) : 'N/A').join(', ');
    },

    getChequeDates(item) {
      if (!item.items || !item.items.length) return '-';
      const chequeDates = [];
      item.items.forEach(invoice => {
        if (invoice.cheque_date) {
          try {
            if (typeof invoice.cheque_date === 'string' && invoice.cheque_date.startsWith('[')) {
              const parsed = JSON.parse(invoice.cheque_date);
              if (Array.isArray(parsed)) chequeDates.push(...parsed);
              else chequeDates.push(invoice.cheque_date);
            } else if (typeof invoice.cheque_date === 'string') {
              chequeDates.push(invoice.cheque_date);
            } else if (Array.isArray(invoice.cheque_date)) {
              chequeDates.push(...invoice.cheque_date);
            }
          } catch (e) {
            chequeDates.push(invoice.cheque_date);
          }
        }
      });
      return chequeDates.length > 0 ? chequeDates.join(', ') : '-';
    },

    getOverdueDays(item) {
      if (!item.items || !item.items.length) return '0';
      if (item.overdue_days) return item.overdue_days;
      let maxOverdueDays = 0;
      const today = new Date();
      item.items.forEach(invoice => {
        if (invoice.due_date) {
          const dueDate = new Date(invoice.due_date);
          if (!isNaN(dueDate.getTime())) {
            const diffTime = today - dueDate;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays > maxOverdueDays) maxOverdueDays = diffDays;
          }
        }
      });
      return maxOverdueDays > 0 ? `${maxOverdueDays} Days Overdue` : '0';
    },

    getDueDatesString(item) {
      if (!item.items || !item.items.length) return 'N/A';
      return item.items.map(inv => inv.due_date || 'N/A').join(', ');
    },

    async fetchSalesRepsFromAPI() {
      try {
        this.salesRepsLoading = true;
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const url = `${this.baseUrl}/api/getSalesRepByUserAreaCodes?userId=${userId}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          },
        });

        if (response.data.success && response.data.data) {
          this.agentListsWithDetails = response.data.data.map(rep => ({
            text: rep.salesRep_name,
            value: rep.id,
            registration: rep.userCode,
            id: rep.id,
            userCode: rep.userCode,
            email: rep.email,
            areaCodes: rep.area_codes,
          })).sort((a, b) => a.text.localeCompare(b.text));
        } else {
          this.agentListsWithDetails = [];
        }
      } catch (error) {
        console.error('❌ Error fetching sales reps from API:', error);
        if (this.$toast) this.$toast.error('Failed to load sales representatives');
        this.agentListsWithDetails = [];
      } finally {
        this.salesRepsLoading = false;
      }
    },

    async fetchDealersFromAPI() {
      try {
        this.dealersLoading = true;
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const url = `${this.baseUrl}/api/getDealersByUserAreaCodes?userId=${userId}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          },
        });

        if (response.data.success && response.data.data) {
          this.dealerListsWithDetails = response.data.data.map(dealer => ({
            text: dealer.dealer_name,
            value: dealer.dealer_code,
            registration: dealer.dealer_code,
          })).sort((a, b) => a.text.localeCompare(b.text));
        } else {
          this.dealerListsWithDetails = [];
        }
      } catch (error) {
        console.error('❌ Error fetching dealers from API:', error);
        if (this.$toast) this.$toast.error('Failed to load dealers');
        this.dealerListsWithDetails = [];
      } finally {
        this.dealersLoading = false;
      }
    },

    async fetchAreasFromAPI() {
      try {
        this.areasLoading = true;
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId') || 1;
        const url = `${this.baseUrl}/api/area/user/${userId}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          },
        });

        if (response.data.success && response.data.data && Array.isArray(response.data.data)) {
          this.areaLists = response.data.data.map(areaCode => ({
            text: areaCode,
            value: areaCode,
            title: areaCode,
          })).sort((a, b) => a.text.localeCompare(b.text));
        } else {
          this.areaLists = [];
        }
      } catch (error) {
        console.error('❌ Error fetching areas from API:', error);
        if (this.$toast) this.$toast.error('Failed to load areas');
        this.areaLists = [];
      } finally {
        this.areasLoading = false;
      }
    },

    formatNumber(value) {
      if (!value && value !== 0) return '0.00';
      const num = parseFloat(value);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    formatDate(dateString) {
      if (!dateString) return null;
      if (dateString instanceof Date) {
        const year = dateString.getFullYear();
        const month = String(dateString.getMonth() + 1).padStart(2, '0');
        const day = String(dateString.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      if (typeof dateString === 'string') {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
      }
      return null;
    },

    formatDateForDisplay(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
      } catch (e) {
        return 'N/A';
      }
      return 'N/A';
    },

    formatDateTimeForDisplay(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
      } catch (e) {
        console.error('Error formatting date/time:', e);
        return 'N/A';
      }
      return 'N/A';
    },

    getReceiptStatusColor(status) {
      if (!status || status === 'undefined') return 'grey';
      const statusLower = status.toLowerCase();
      if (statusLower === 'collected') return 'success';
      if (statusLower === 'reversed') return 'error';
      if (statusLower === 'request revers' || statusLower === 'request reversal') return 'warning';
      if (statusLower === 'completed' || statusLower === 'paid') return 'success';
      if (statusLower === 'pending') return 'warning';
      if (statusLower === 'cancelled') return 'error';
      if (statusLower === 'partial') return 'info';
      return 'primary';
    },

    clearDateRange() {
      this.dates = [];
    },

    getDateRangeBounds() {
      if (!this.dates || this.dates.length === 0) return null;

      if (this.dates.length === 1) {
        const singleDay = this.formatDate(this.dates[0]);
        if (!singleDay) return null;
        return { from: singleDay, to: singleDay };
      }

      const formattedDates = this.dates
        .map(d => this.formatDate(d))
        .filter(Boolean)
        .sort();

      if (formattedDates.length === 0) return null;

      return {
        from: formattedDates[0],
        to: formattedDates[formattedDates.length - 1],
      };
    },

    backPageRoute() {
      this._saveFiltersToSession();
      this.$router.go(-1);
    },

    closeReversalDialog() {
      this.rivesDialog = false;
      this.itemToDelete = null;
    },

    buildFilterParams() {
      const params = {};
      const userId = localStorage.getItem('userId') || 1;

      params.userId = userId;

      if (this.selectedAgent && this.selectedAgent.length > 0) params.saleRep_id = this.selectedAgent.join(',');
      if (this.selectedRoute && this.selectedRoute.length > 0) params.route_type = this.selectedRoute.join(',');
      if (this.selectedDealer && this.selectedDealer.length > 0) params.dealer_code = this.selectedDealer.join(',');
      if (this.selectDistrict && this.selectDistrict.length > 0) params.area_code = this.selectDistrict.join(',');
      if (this.selectedStatus && this.selectedStatus.length > 0) params.payment_status = this.selectedStatus.join(',');
      if (this.selectedCollectionType && this.selectedCollectionType.length > 0) params.payment_method = this.selectedCollectionType.join(',');
      if (this.selectedCompany && this.selectedCompany.length > 0) params.ar_company = this.selectedCompany.join(',');

      const dateBounds = this.getDateRangeBounds();
      if (dateBounds) {
        params.date_from = dateBounds.from;
        params.date_to = dateBounds.to;
      }

      return params;
    },

    async fetchAllFilteredData() {
      const token = localStorage.getItem('token');
      const url = `${this.baseUrl}/api/receipt-list`;
      const baseParams = this.buildFilterParams();

      const maxPerPage = 1000;

      try {
        let allData = [];
        let currentPage = 1;
        let lastPage = 1;

        const firstParams = { ...baseParams, perPage: maxPerPage, page: currentPage };

        const firstResponse = await axios.get(url, {
          params: firstParams,
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          },
        });

        if (firstResponse.data.success && firstResponse.data.data) {
          const firstRows = Array.isArray(firstResponse.data.data)
            ? firstResponse.data.data
            : (firstResponse.data.data.data || []);
          allData = [...firstRows];

          const firstPagination = firstResponse.data.pagination || firstResponse.data.data || firstResponse.data;
          lastPage = parseInt(firstPagination.last_page ?? firstPagination.total_pages ?? 1, 10);

          if (lastPage > 1) {
            const remainingPages = [];
            for (let page = 2; page <= lastPage; page++) remainingPages.push(page);

            const pagePromises = remainingPages.map(async (page) => {
              const params = { ...baseParams, perPage: maxPerPage, page };
              const response = await axios.get(url, {
                params,
                headers: {
                  Authorization: token ? `Bearer ${token}` : '',
                  'Content-Type': 'application/json',
                },
              });
              if (response.data.success && response.data.data) {
                return Array.isArray(response.data.data)
                  ? response.data.data
                  : (response.data.data.data || []);
              }
              return [];
            });

            const allPageResults = await Promise.all(pagePromises);
            allPageResults.forEach(pageData => { allData = [...allData, ...pageData]; });
          }

          const term = (this.search || '').trim().toLowerCase();
          if (term) {
            allData = allData.filter(item => {
              if (!item) return false;
              const parts = [
                item.saleRep_name,
                item.saleRep_userCode,
                item.dealer_name,
                item.dealer_code,
                item.receipt_id,
                this.getManualReceiptNumber(item),
              ];
              if (Array.isArray(item.items)) {
                item.items.forEach(inv => {
                  if (inv && inv.document_no) parts.push(inv.document_no);
                });
              }
              return parts.some(part => {
                if (part === null || part === undefined) return false;
                return String(part).toLowerCase().includes(term);
              });
            });
          }

          return allData;
        } else {
          return [];
        }
      } catch (error) {
        console.error('❌ Error fetching data for export:', error);
        if (error.response) {
          console.error('Response status:', error.response.status);
          console.error('Response data:', error.response.data);
        }
        throw error;
      }
    },

    parseJsonArrayField(value) {
      if (!value) return '-';
      try {
        if (typeof value === 'string' && value.trim().startsWith('[')) {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed) && parsed.length === 0) return '-';
          return Array.isArray(parsed) ? parsed.join(', ') : String(parsed);
        }
        return String(value);
      } catch (e) {
        return String(value);
      }
    },

    getFilterSummary() {
      const filters = [];

      if (this.selectedAgent && this.selectedAgent.length > 0) {
        const agentNames = this.selectedAgent.map(id => {
          const agent = this.agentListsWithDetails.find(a => a.value === id);
          return agent ? agent.text : id;
        });
        filters.push(`Sales Rep: ${agentNames.join(', ')}`);
      }
      if (this.selectedRoute && this.selectedRoute.length > 0) filters.push(`Route: ${this.selectedRoute.join(', ')}`);
      if (this.selectedDealer && this.selectedDealer.length > 0) {
        const dealerNames = this.selectedDealer.map(code => {
          const dealer = this.dealerListsWithDetails.find(d => d.value === code);
          return dealer ? dealer.text : code;
        });
        filters.push(`Dealer: ${dealerNames.join(', ')}`);
      }
      if (this.selectDistrict && this.selectDistrict.length > 0) filters.push(`Area: ${this.selectDistrict.join(', ')}`);
      if (this.selectedStatus && this.selectedStatus.length > 0) filters.push(`Payment Status: ${this.selectedStatus.join(', ')}`);
      if (this.selectedCollectionType && this.selectedCollectionType.length > 0) filters.push(`Collection Type: ${this.selectedCollectionType.join(', ')}`);
      if (this.selectedCompany && this.selectedCompany.length > 0) filters.push(`Company: ${this.selectedCompany.length} selected`);

      const dateBounds = this.getDateRangeBounds();
      if (dateBounds) {
        if (dateBounds.from === dateBounds.to) filters.push(`Date: ${dateBounds.from}`);
        else filters.push(`Date Range: ${dateBounds.from} to ${dateBounds.to}`);
      }

      if (this.search && this.search.trim()) filters.push(`Search: "${this.search}"`);

      return filters.length > 0 ? filters.join(' | ') : 'No filters applied';
    },

    /* ------------------------------------------------------------------ */
    /*  PDF EXPORT — Piyestra & SFA logos on FIRST page only               */
    /* ------------------------------------------------------------------ */
    async exportPDF() {
      if (this.$toast) this.$toast.info('Preparing PDF export...');
      this.loading = true;

      try {
        const allData = await this.fetchAllFilteredData();

        if (!allData || allData.length === 0) {
          if (this.$toast) this.$toast.warning('No data available to export');
          this.loading = false;
          return;
        }

        const columns = this.getExportColumns();
        const rows = this.buildExportRows(allData);

        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });

        // Page dimensions (A3 landscape: 420 x 297 mm)
        const pageWidth = doc.internal.pageSize.getWidth();

        // ─── Logo section (FIRST PAGE ONLY) ───────────────────────────
        let headerY = 10;

        try {
          const logo1Base64 = await this.loadImageAsBase64(
            require('@/img/company_logo/logo-dark 2.png')
          );
          const logo2Base64 = await this.loadImageAsBase64(
            require('@/img/company_logo/g-sfa.png')
          );

          if (logo1Base64) {
            doc.addImage(logo1Base64, 'PNG', 14, headerY, 40, 15);
          }
          if (logo2Base64) {
            doc.addImage(logo2Base64, 'PNG', 58, headerY, 40, 15);
          }
        } catch (logoError) {
          console.warn('⚠️ Could not load logos for PDF:', logoError);
        }
        // ──────────────────────────────────────────────────────────────

        // Title (centered)
        doc.setFontSize(18);
        doc.setFont(undefined, 'bold');
        doc.text('Total Collections Report', pageWidth / 2, headerY + 5, { align: 'center' });

        // Generated date (centered)
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(
          `Generated on: ${new Date().toLocaleString()}`,
          pageWidth / 2,
          headerY + 13,
          { align: 'center' }
        );

        let filterY = headerY + 22;
        doc.setFontSize(9);
        const filterSummary = this.getFilterSummary();
        const splitFilterText = doc.splitTextToSize(
          `Filters applied: ${filterSummary}`,
          pageWidth - 30
        );
        doc.text(splitFilterText, 14, filterY);
        filterY += splitFilterText.length * 5 + 3;

        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');
        doc.text(`Total Rows: ${rows.length}`, 14, filterY);
        filterY += 8;
        doc.setFont(undefined, 'normal');

        const head = [columns.map(c => c.label)];
        const body = rows.map(row => columns.map(c => {
          const v = row[c.key];
          return v === undefined || v === null || v === '' ? '-' : v;
        }));

        const columnStyles = {};
        columns.forEach((col, i) => {
          columnStyles[i] = { cellWidth: 'auto', halign: 'left' };
        });

        doc.autoTable({
          head,
          body,
          startY: filterY,
          styles: {
            fontSize: 7.5,
            cellPadding: 1.5,
            overflow: 'linebreak',
            halign: 'left',
            valign: 'middle',
            lineWidth: 0.1,
            lineColor: [200, 200, 200],
          },
          headStyles: {
            fillColor: [1, 87, 155],
            textColor: [255, 255, 255],
            fontSize: 7.5,
            fontStyle: 'bold',
            halign: 'center',
            valign: 'middle',
            cellPadding: 2,
          },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          columnStyles,
          margin: { left: 8, right: 8, top: 8, bottom: 8 },
          tableWidth: 'auto',
          showHead: 'everyPage',
          pageBreak: 'auto',
          didParseCell: (data) => {
            const numericKeys = ['sno', 'total_collection', 'invoice_amount'];
            if (data.section === 'body' && numericKeys.includes(columns[data.column.index].key)) {
              data.cell.styles.halign = 'right';
            }
          },
        });

        // ⚠️ NO logo loop for subsequent pages — logos appear ONLY on page 1

        const fileName = `total_collections_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.pdf`;
        doc.save(fileName);

        if (this.$toast) this.$toast.success(`PDF exported with ${rows.length} rows`);
        this.logDocumentDownload(fileName, 'pdf');

      } catch (error) {
        console.error('❌ Error exporting PDF:', error);
        if (this.$toast) this.$toast.error('Failed to export PDF: ' + (error.message || 'Unknown error'));
      } finally {
        this.loading = false;
      }
    },

    truncateText(text, maxLength) {
      if (!text || text === '-' || text === 'N/A') return text;
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength - 3) + '...';
    },

    /* ------------------------------------------------------------------ */
    /*  EXCEL EXPORT                                                       */
    /* ------------------------------------------------------------------ */
    async exportExcel() {
      if (this.$toast) this.$toast.info('Preparing Excel export...');
      this.loading = true;

      try {
        const allData = await this.fetchAllFilteredData();

        if (!allData || allData.length === 0) {
          if (this.$toast) this.$toast.warning('No data available to export');
          this.loading = false;
          return;
        }

        const columns = this.getExportColumns();
        const rows = this.buildExportRows(allData);

        const headerRow = columns.map(c => c.label);
        const aoa = [headerRow, ...rows.map(row =>
          columns.map(c => {
            const v = row[c.key];
            return v === undefined || v === null || v === '' ? '-' : v;
          })
        )];

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        ws['!cols'] = columns.map(c => ({ wch: Math.max(10, Math.ceil(c.width / 6)) }));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Receipt Collections');
        const fileName = `total_collections_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        XLSX.writeFile(wb, fileName);

        if (this.$toast) this.$toast.success(`Excel exported with ${rows.length} rows (${allData.length} receipts)`);
        this.logDocumentDownload(fileName, 'excel');

      } catch (error) {
        console.error('❌ Error exporting Excel:', error);
        if (this.$toast) this.$toast.error('Failed to export Excel: ' + (error.message || 'Unknown error'));
      } finally {
        this.loading = false;
      }
    },

    fetchReceiptData() {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('New search initiated');
      }

      this.cancelTokenSource = axios.CancelToken.source();

      this.loading = true;
      const token = localStorage.getItem('token');
      const url = `${this.baseUrl}/api/receipt-list`;
      const params = this.buildFilterParams();

      params.perPage = this.perPage;
      params.page = this.currentPage;

      axios
        .get(url, {
          params,
          cancelToken: this.cancelTokenSource.token,
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.data && response.data.success && response.data.data) {
            const payload = response.data;

            const pagination = payload.pagination || payload.data || payload;

            let rows = [];
            if (Array.isArray(payload.data)) {
              rows = payload.data;
            } else if (payload.data && Array.isArray(payload.data.data)) {
              rows = payload.data.data;
            }

            this.receiptData = rows;

            const toInt = (v, fallback) => {
              const n = parseInt(v, 10);
              return isNaN(n) ? fallback : n;
            };

            this.currentPage = toInt(pagination.current_page ?? pagination.page, this.currentPage);
            this.lastPage = toInt(pagination.last_page ?? pagination.total_pages, 1);
            this.totalRecords = toInt(
              pagination.total ?? pagination.total_count ?? pagination.total_records,
              rows.length
            );
            this.perPage = toInt(pagination.per_page ?? pagination.perPage, this.perPage);
            this.fromRecord = toInt(pagination.from, 0);
            this.toRecord = toInt(pagination.to, rows.length);

            if (!this.totalRecords || this.totalRecords < rows.length) {
              this.totalRecords = Math.max(rows.length, this.lastPage * this.perPage);
            }
            if (!this.lastPage || this.lastPage < 1) {
              this.lastPage = Math.max(1, Math.ceil(this.totalRecords / this.perPage));
            }

            this.loadedPage = this.currentPage;
            this.loadedPerPage = this.perPage;
          } else {
            console.error('❌ API returned unsuccessful response:', response.data);
            this.receiptData = [];
            this.totalRecords = 0;
            this.lastPage = 1;
            if (this.$toast) this.$toast.warning(response.data?.message || 'No data found');
          }
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            // request superseded
          } else {
            console.error('❌ Error fetching receipt data:', error);
            this.receiptData = [];
            this.totalRecords = 0;
            this.lastPage = 1;

            if (error.response) {
              if (this.$toast) this.$toast.error(error.response.data?.message || 'Failed to load data');
            } else if (error.request) {
              if (this.$toast) this.$toast.error('Network error. Please check your connection.');
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    viewItem(item) {
      // Save filters BEFORE navigating to view page
      this._saveFiltersToSession();
      this.updateSharedDataCollection(item);
      this.$router.push(`/total-collections-view/${item.receipt_id}`);
    },

    confirmDelete(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },

    rivesitem(item) {
      this.itemToDelete = item;
      this.rivesDialog = true;
    },

    deleteItem() {
      this.deleteLoading = true;
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId') || 1;
      const url = `${this.baseUrl}/api/receipt/${this.itemToDelete.id}?userId=${userId}`;

      axios
        .delete(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.data.success) {
            if (this.$toast) this.$toast.success(response.data.message || 'Deleted successfully');

            const deletedId = this.itemToDelete.id;
            this.receiptData = this.receiptData.filter(r => r.id !== deletedId);

            this.deleteDialog = false;
            this.itemToDelete = null;
            this.fetchReceiptData();
          } else {
            if (this.$toast) this.$toast.error(response.data.message || 'Failed to delete record');
          }
        })
        .catch(error => {
          console.error('❌ Error deleting record:', error);
          if (this.$toast) this.$toast.error(error.response?.data?.message || 'An error occurred while deleting the record');
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },

    processReversal() {
      this.reversalLoading = true;
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId') || 1;

      const receiptId = this.itemToDelete.id;
      const url = `${this.baseUrl}/api/receipts/${receiptId}/reversal-request-date`;

      const payload = { userId: parseInt(userId) };

      axios
        .put(url, payload, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        })
        .then(response => this.handleReversalResponse(response))
        .catch(() => {
          axios
            .patch(url, payload, {
              headers: {
                Authorization: token ? `Bearer ${token}` : '',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
            })
            .then(response => this.handleReversalResponse(response))
            .catch(() => {
              const getUrl = `${this.baseUrl}/api/receipts/${receiptId}/reversal-request-date?userId=${userId}`;
              axios
                .get(getUrl, {
                  headers: {
                    Authorization: token ? `Bearer ${token}` : '',
                    'Accept': 'application/json'
                  },
                })
                .then(response => this.handleReversalResponse(response))
                .catch(getError => {
                  console.error('❌ All methods failed:', getError);
                  this.handleReversalError(getError);
                });
            });
        });
    },

    handleReversalResponse(response) {
      if (response.data.success) {
        if (this.$toast) this.$toast.success(response.data.message || 'Reversal completed successfully');
        this.closeReversalDialog();
        setTimeout(() => this.fetchReceiptData(), 500);
      } else {
        if (this.$toast) this.$toast.error(response.data.message || 'Failed to process reversal');
        this.reversalLoading = false;
      }
    },

    handleReversalError(error) {
      console.error('❌ Error processing reversal:', error);

      let errorMessage = 'An error occurred while processing the reversal';

      if (error.response) {
        if (error.response.data && error.response.data.message) errorMessage = error.response.data.message;
        else if (error.response.status === 400) errorMessage = 'Invalid request. Please check the receipt ID and user information.';
        else if (error.response.status === 404) errorMessage = `Receipt with ID ${this.itemToDelete?.id} not found.`;
        else if (error.response.status === 405) errorMessage = 'The API endpoint does not support this operation. Please contact support.';
        else if (error.response.status === 409) errorMessage = 'This receipt may have already been reversed or cannot be reversed.';
        else if (error.response.status === 500) errorMessage = 'Server error. Please contact support.';
        else if (error.response.status === 401) errorMessage = 'Authentication failed. Please login again.';
        else if (error.response.status === 403) errorMessage = 'You do not have permission to perform this action.';
      } else if (error.request) {
        errorMessage = 'Unable to connect to the server. Please check your network connection.';
      }

      if (this.$toast) this.$toast.error(errorMessage);
      this.reversalLoading = false;
    },

    async logDocumentDownload(fileName, fileType) {
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        await axios.post(
          `${this.baseUrl}/api/log-document-download`,
          { user_id: userId, file_type: fileType, file_name: fileName, entity_area: 'Receipt Collections' },
          { headers: { Authorization: token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' } },
        );
      } catch (error) {
        console.error('❌ Error logging download:', error);
      }
    },

    setupEventListeners() {
      EventBus.on('collectionsRecodeManagementButtonClick2', () => {
        this.fetchReceiptData();
      });
    },

    removeEventListeners() {
      EventBus.off('collectionsRecodeManagementButtonClick2');
    },

    applyFilters() {
      this.currentPage = 1;
      this.fetchReceiptData();
    },
  },

  watch: {
    search: {
      handler: _.debounce(function() {
        this.currentPage = 1;
        this.fetchReceiptData();
        this._saveFiltersToSession();
      }, 400),
    },
    selectedAgent: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedRoute: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedDealer: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectDistrict: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedStatus: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedCollectionType: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    selectedCompany: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },
    dates: { handler() { this.applyFilters(); this._saveFiltersToSession(); }, deep: true },

    currentPage(newPage) {
      if (newPage === this.loadedPage) return;
      this.fetchReceiptData();
      this._saveFiltersToSession();
    },

    perPage(newPerPage) {
      if (newPerPage === this.loadedPerPage) return;
      this.currentPage = 1;
      this.fetchReceiptData();
      this._saveFiltersToSession();
    },

    panelOpen: {
      handler() {
        this._saveFiltersToSession();
      },
      deep: true,
    },
  },

  mounted() {
    this.permissions = getPermissions(0, 'Module Name');
    if (!this.permissions.read) {
      this.showSnackbar ? this.showSnackbar('Access Denied', 'error') : alert('Access Denied');
      this.$router.push('/dashboard');
      return;
    }

    // Restore filters before fetching data
    const restored = this._restoreFiltersFromSession();

    this.setupEventListeners();

    this.fetchSalesRepsFromAPI();
    this.fetchDealersFromAPI();
    this.fetchAreasFromAPI();

    // Fetch data (with restored filters & page if available)
    if (restored) {
      // Ensure currentPage is synced with loadedPage so watcher won't re-fetch unnecessarily
      this.loadedPage = this.currentPage;
      this.loadedPerPage = this.perPage;
    }
    this.fetchReceiptData();
  },

  beforeUnmount() {
    // Save filters one last time
    this._saveFiltersToSession();
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('Component unmounting');
    }
    this.removeEventListeners();
  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/user_management/users_list.scss" as *;
@use "../../styles/collection_management/collection_management.scss" as *;

.invoice-amount-item {
  border-left: 2px solid #01579B;
}

.invoice-amount-item:last-child {
  margin-bottom: 0;
}

.table-wrapper {
  position: relative;
  overflow: hidden;
}

:deep(.v-data-table) {
  .v-table__wrapper {
    overflow-y: auto !important;
    overflow-x: auto !important;
  }

  .v-table__thead {
    position: sticky;
    top: 0;
    z-index: 10;
    background: white;
  }

  .v-data-table__tr {
    height: auto !important;
    min-height: 36px !important;
  }

  .v-data-table__td {
    padding: 4px 8px !important;
    line-height: 1.2 !important;
  }

  .v-data-table__th {
    padding: 6px 8px !important;
    line-height: 1.2 !important;
    font-size: 12px !important;
  }

  .v-data-table__td .v-card {
    margin-bottom: 2px !important;
    padding: 2px 4px !important;
  }

  .v-data-table__td .v-chip {
    margin-bottom: 1px !important;
  }

  .v-divider {
    margin: 1px 0 !important;
  }

  .text-caption {
    line-height: 1.1 !important;
    font-size: 10px !important;
  }

  .text-body-2 {
    line-height: 1.2 !important;
    font-size: 12px !important;
  }

  .font-weight-medium {
    line-height: 1.2 !important;
  }
}

:deep(.v-expansion-panel-title) {
  min-height: 40px !important;
  padding: 8px 16px !important;
  font-size: 13px !important;
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 4px 16px 12px !important;
}
</style>